<script setup>
import { useCategoryStore } from "@/stores/useCategoryStore";
import DeleteConfirmModal from "@/components/Generics/DeleteConfirmModal.vue";

const emit = defineEmits(["close", "refresh", "notify"]);
const categoryStore = useCategoryStore();

// ===============================
// Tratamento de erro específico
// ===============================
function buildCategoryDeleteError(error) {
  const defaultMessage =
    "Não é possível excluir esse GÊNERO porque existe TEXTO cadastrado vinculado a ele.";

  const foreignKeyError =
    "Erro interno ao remover a categoria: Cannot delete or update a parent row: a foreign key constraint fails (`litterae`.`texts`, CONSTRAINT `fk_texts_category1` FOREIGN KEY (`category_id`) REFERENCES `categories` (`category_id`))";

  const raw =
    error?.response?.data?.message ||
    error?.message ||
    "";

  const looksLikeFK =
    raw.includes("foreign key constraint fails") ||
    raw.toLowerCase().includes("constraint") ||
    raw.toLowerCase().includes("foreign key");

  if (raw.trim() === foreignKeyError.trim() || looksLikeFK) {
    return (
      "Este gênero está vinculado a um ou mais Textos e não pode ser removido.\n" +
      "Para excluí-lo, remova todos os textos associados a este gênero primeiro."
    );
  }

  return raw || defaultMessage;
}

async function onConfirmDelete() {
  try {
    await categoryStore.deleteCategoryById(categoryStore.idCategory);

    categoryStore.shouldForcePageOne = true;

    emit("notify", {
      type: "success",
      message: "Gênero apagado com sucesso.",
    });

    emit("refresh");
    emit("close");
  } catch (error) {
    const msg = buildCategoryDeleteError(error);

    emit("notify", {
      type: "error",
      message: msg,
    });

    throw new Error(msg);
  }
}
</script>

<template>
  <DeleteConfirmModal
    :show="true"
    title="Apagar Gênero"
    messageTitle="Tem certeza que deseja excluir este gênero?"
    messageSubtitle="Esta ação não pode ser desfeita."
    confirmText="Sim, excluir"
    cancelText="Cancelar"
    loadingText="Apagando..."
    :onConfirm="onConfirmDelete"
    @close="emit('close')"
  />
</template>
